// extracted by mini-css-extract-plugin
export var bodyRow = "_gb-d";
export var cardColumns = "_gb-e";
export var ellipsesOverflow = "_gb-2";
export var flatBottomCorners = "_gb-3";
export var flatTopCorners = "_gb-4";
export var headerActionsDropdown = "_gb-f";
export var headerBottomRow = "_gb-c";
export var headerTopRow = "_gb-b";
export var orderDetailsWrapper = "_gb-0";
export var orderInfoContainer = "_gb-1";
export var productDetails = "_gb-9";
export var productImage = "_gb-5";
export var responsiveTable = "_gb-8";
export var shipmentContainer = "_gb-a";
export var tableBottomLeft = "_gb-6";
export var tableBottomRight = "_gb-7";
export var trackingLink = "_gb-g";